export default "__VITE_ASSET__CrBhQtsG__"